export default "__VITE_ASSET__d946d4af__"